import { useEffect, useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { Nav, Navbar, Offcanvas, Container } from 'react-bootstrap';

import AOS from "aos";
import "aos/dist/aos.css"; 

import logo from './assets/ALLTEAM Just Arrow-09.png';
import bgLogo from './assets/ALLTEAM NEW LOGO-06.png';

import './App.css';

import Home from './components/home.js';
import Capabilities from './components/capabilities.js';
import WhatWeDo from './components/whatwedo.js';
import Insights from './components/insights.js';
import Company from './components/company.js';
import Partners from './components/partners.js';
import Careers from './components/careers.js';
import Contact from './components/contact.js';
import Query from './components/query.js';
import FloatingAvatar from './components/avatar.js';

function App() {
  const [whatWeDo, setWhatWeDo] = useState(null);
  const [showWhatWeDo, setShowWhatWeDo] = useState(false);
  // const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      // if (window.scrollY > lastScrollY) {
      //   // scrolling down → hide navbar
      //   setShowNavbar(true);
      // } else {
      //   // scrolling up → show navbar
      //   setShowNavbar(true);
      // }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    AOS.init({
      // Optional: Configure AOS with desired settings
      duration: 1000, // Animation duration
      once: true, // Whether animation should only happen once
    });
    AOS.refresh(); // Refresh AOS to detect newly added elements
  }, []);

  const handleWhatWeDo = (event) => {
    // window.scrollTo(0, 0);
    const type = event.currentTarget.dataset.type;
    setWhatWeDo(type);
    setShowWhatWeDo(["Capabilities","Industries"].includes(type));
  };

  const closeWhatWeDo = (event) => {
    showWhatWeDo && setShowWhatWeDo(false);
  }

  return (
    <div onMouseUp={closeWhatWeDo} className='position-relative'>
      <Navbar collapseOnSelect expand="md" data-bs-theme="dark" sticky="top" className={`m-0 p-1 app-navbar`}>
        <Container fluid className="m-0 p-0">
          <Navbar.Brand className='p-0 mx-1 d-flex justify-content-center' >
            <Link to={'/'} className="logo-link" onClick={() => window.scrollTo(0, 0)}>
              <img className="logo normal" src={bgLogo} alt="ALLTEAM" />
              <img className="logo hover" src={logo} alt="ALLTEAM" />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="app-navbar-nav" className="ms-auto" />
          <Navbar.Offcanvas id='app-navbar-nav' placement="top" data-bs-theme="dark">
            <Offcanvas.Header closeButton>
              {/*
              <Offcanvas.Title id={`basic-navbar-offcanvas`}>
                ALLTEAM
              </Offcanvas.Title>
              */}
            </Offcanvas.Header>
            <Offcanvas.Body>
            <Nav className="mx-auto" >
              <Nav.Link eventKey="10" as={Link} to="#" data-type="Capabilities" onClick={handleWhatWeDo} >
                  <span>Capabilities</span>
              </Nav.Link>
              <Nav.Link eventKey="20" as={Link} to="#" data-type="Industries" onClick={handleWhatWeDo} >
                  <span>Industries</span>
              </Nav.Link>
              <Nav.Link eventKey="30"as={Link} to="/insights"> 
                  <span>Insights</span>
              </Nav.Link>
              <Nav.Link eventKey="40"as={Link} to="/company" >
                  <span>Company</span>
              </Nav.Link>
              <Nav.Link eventKey="50"as={Link} to="/partners" >
                  <span>Partners</span>
              </Nav.Link>
              <Nav.Link eventKey="40"as={Link} to="/careers" >
                  <span>Careers</span>
              </Nav.Link>
              <Nav.Link eventKey="90"as={Link} to="/contact" >
                  <span>Contact</span>
              </Nav.Link>
            </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
      <Container fluid className="m-0 p-0">
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/capabilities/:capability" element={<Capabilities />} />
            <Route exact path="/insights" element={<Insights />} />
            <Route exact path="/company" element={<Company />} />
            <Route exact path="/partners" element={<Partners />} />
            <Route exact path="/careers" element={<Careers />} />
            <Route exact path="/contact" element={<Contact />} />
            <Route exact path="/query" element={<Query />} />
          </Routes>
      </Container>
      <div className={`nav-overlay ${showWhatWeDo ? 'd-flex' : 'd-none'}`}>
        <WhatWeDo type={whatWeDo} />
      </div>

      {/* Floating avatar window */}
      <FloatingAvatar setWhatWeDo={setWhatWeDo} whatWeDo={whatWeDo} setShowWhatWeDo={setShowWhatWeDo}/>
    </div>);
}

export default App;
